import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 70px;
    margin-bottom: 70px;
`;
const TitleContainer = styled.div`
    font-size: 2.25rem;
    font-weight: bold;
    align-self: center;
    font-family: Arial, Helvetica, sans-serif;
    margin-bottom: 5px;
`;
const SubTitleContainer = styled.div`
    font-size: 1.25rem;
    align-self: center;
    font-family: Arial, Helvetica, sans-serif;
`;
interface IProps {
  title: string;
  subtitle?: string;
}

const Title: React.FC<IProps> = ({ title, subtitle }) => (
  <Container>
    <TitleContainer>{title.toUpperCase()}</TitleContainer>
    <SubTitleContainer>{subtitle}</SubTitleContainer>
  </Container>
);

export default Title;
